import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { TypeModalityModel } from '../../models/consult/type-modality.model';
export class GetTypeModalityUseCase implements UseCase<void, TypeModalityModel> {
    constructor(private ConsultRepository: ConsultRepository) { }
    execute(): Observable<TypeModalityModel> {
        return this.ConsultRepository.getTypeModality();
    }
}